import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, Icon, LinkButton, Modal, HeaderFeatureIntro } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import { getAnalyticsLanguageInfo } from 'src/utils/analytics/getAnalyticsLanguageInfo';
import { getAnalyticsUserInfo } from 'src/utils/analytics/getAnalyticsUserInfo';
import { useUserContext } from 'src/context/user';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'homeScreen_myActivitiesModal_title' },
  description: { id: 'homeScreen_myActivitiesModal_description' },
  primaryCta: { id: 'homeScreen_myActivitiesModal_CTA_title' },
  secondaryCta: { id: 'plans_page_interstitial_maybe_later' },
});

export const MyActivitiesIntroModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  progressIndicator?: string;
}> = ({ isOpen, onClose, progressIndicator }) => {
  const intl = useIntl();
  const { user } = useUserContext();

  return (
    <Modal hideCloseButton isOpen={isOpen}>
      <S.ModalContent>
        <HeaderFeatureIntro feature="my-activities" />

        <S.ModalBody>
          <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
          <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        </S.ModalBody>

        <S.ModalFooter>
          <S.ButtonWrapper>
            <LinkButton
              data-testid="my_activities_intro_cta"
              buttonSize="medium"
              buttonType="primary"
              wide
              href={ROUTES.myActivities}
              onClick={() => {
                window.dataLayer.push({
                  event: 'click_cta',
                  action: 'exp_20250326_my_activities',
                  page_screen_type: window.location.pathname,
                  page_screen_name: window.location.pathname,
                  click_area: 'My Activities Intro Modal',
                  click_path: 'My Activities Intro Modal',
                  ...getAnalyticsLanguageInfo(intl),
                  ...getAnalyticsUserInfo(user),
                });
                onClose();
              }}
            >
              <S.PrimaryButtonContent>
                <Icon name="statistics" />
                {intl.formatMessage(msgs.primaryCta)}
              </S.PrimaryButtonContent>
            </LinkButton>
          </S.ButtonWrapper>

          <S.ButtonWrapper>
            <Button
              data-testid="my_activities_intro_maybe_later"
              buttonSize="large"
              buttonType="secondary"
              wide
              onClick={onClose}
            >
              {intl.formatMessage(msgs.secondaryCta)}
            </Button>
          </S.ButtonWrapper>
        </S.ModalFooter>

        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};
